import React, { useEffect, useRef, useState } from 'react'
import styles from "./VentasDetail.module.scss"
import { formatDoc, formatNumber } from '../../../services/Local-services';
import { MerchantCobroMovimientoGet } from '../../../services/hooli-services/Ventas/MerchantCobroMovimientoGet';
import { CircularIndeterminate } from '../../../components';

export default function VentasDetail({user}) {
    const [info, setInfo] = useState([])
    const [load, setLoad] = useState(true)

    const getInfo = async() => {
        setLoad(true)
        const response =  await MerchantCobroMovimientoGet({posTransaccionUUID: user.Operación})
        setInfo(response)
        setLoad(false)
    }
    useEffect(() => {
        getInfo()
    }, [])
    return (
        <>
        {load ? <div className={styles.contianerLoad}><CircularIndeterminate/></div> : <div className={styles.containerData}>
            <div className={styles.containerDataRow}>
                <h3>Fecha:</h3>
                <p>{user?.Fecha ?? "N/A"}</p>
            </div>
            <div className={styles.containerDataRow}>
                <h3>Cliente:</h3>
                <p>{user?.Cliente ?? "N/A"}</p>
            </div>
            <div className={styles.containerDataRow}>
                <h3>DNI:</h3>
                <p>{user?.DNI ? formatDoc(user?.DNI) : "N/A"}</p>
            </div>
            <div className={styles.containerDataRow}>
                <h3>Método de pago:</h3>
                <p>{user["Método de pago"]}</p>
            </div>
            <div className={styles.containerDataRow}>
                <h3>Canal:</h3>
                <p>{user?.Canal ?? "N/A"}</p>
            </div>
            <div className={styles.containerDataRow}>
                <h3>Referencia:</h3>
                <p>{user?.Referencia ?? "N/A"}</p>
            </div>
            <div className={styles.containerDataRow}>
                <h3>Comprobante:</h3>
                <p>{user?.Comprobante ?? "N/A"}</p>
            </div>
            <div className={styles.containerDataRow}>
                <h3>Gateway IPG ID:</h3>
                <p>{user?.infoAutorizacion?.paywalletTransaccionIpgId ?? "N/A"}</p>
            </div>
            <div className={styles.containerDataRow}>
                <h3>Gateway Order ID:</h3>
                <p>{user?.infoAutorizacion?.paywalletTransaccionOrderId ?? "N/A"}</p>
            </div>
            <div className={styles.containerDataRow}>
                <h3>Debin ID:</h3>
                <p>{user?.infoAutorizacion?.debin ?? "N/A"}</p>
            </div>
            <div className={styles.containerDataRow}>
                <h3>Monto:</h3>
                <p>{user?.Monto ? formatNumber(user?.Monto, false) : "N/A"}</p>
            </div>
            {info.length > 0 ? info.map((e) => (
                <div className={styles.containerDataRow}>
                    <h3>{e.tipoMovimientoNombre}:</h3>
                    <p>{e?.movimientoMonto ? formatNumber(e?.movimientoMonto, false) : "N/A"}</p>
                </div>
            )) : ""} 
        </div>}</>
    );
}
